import React, { Component } from 'react';
import { ErrorsPages, ErrorPageLink} from 'react-template';

class Forbidden extends Component {

    getLinks(){
        return(
            <div>
                <ErrorPageLink url='/logout' descricao='Logout'/>
                <ErrorPageLink url='/' descricao='Início'/>
            </div>
        )
    }

    render() {
        return (
            <ErrorsPages codigo={403} links={this.getLinks()}/>
        );
    }
}

export default Forbidden;


// WEBPACK FOOTER //
// ./src/view/error/Forbidden.js